import request from "./core/index";

// Define the interfaces for Trust testimonial data
export interface TrustTestimonial {
  id: number;
  client: string;
  contactPerson: string;
  content: string;
  logoUrl: string;
  createdAt: string;
  seq: number;
}

/**
 * Fetch trust testimonials from the API
 * @returns Promise with API response containing trust testimonials
 */
export const fetchTrusts = async (): Promise<TrustTestimonial[]> => {
  const url = `/api/trusts`;
  return request.get<TrustTestimonial[]>(url);
}; 